import {
  AuthActionStack,
  AuthPageContainer,
} from '@affine/component/auth-components';
import {
  type GetInviteInfoQuery,
  WorkspaceMemberStatus,
} from '@affine/graphql';
import { useI18n } from '@affine/i18n';
import { BRAND_DISPLAY_NAME } from '@streamlain/brand';
import type { ReactNode } from 'react';

import { Button } from '../../ui/button';
import { InviteSummary } from './invite-summary';
import * as styles from './styles.css';

export const RequestToJoinPage = ({
  inviteInfo,
  requestToJoin,
  loading,
  journey,
}: {
  inviteInfo?: GetInviteInfoQuery['getInviteInfo'];
  requestToJoin: () => void;
  loading?: boolean;
  journey?: ReactNode;
}) => {
  const t = useI18n();
  const workspaceName = inviteInfo?.workspace.name ?? BRAND_DISPLAY_NAME;
  const actionLabel =
    inviteInfo?.status === WorkspaceMemberStatus.Pending
      ? t['com.streamlain.notification.invitation.accept']()
      : t['com.streamlain.request-to-join-workspace.button']();

  return (
    <AuthPageContainer
      visual="brand"
      title={t['com.streamlain.invite.title']()}
      subtitle={BRAND_DISPLAY_NAME}
    >
      <div className={styles.inviteCardBody}>
        <InviteSummary
          inviteInfo={inviteInfo}
          fallbackWorkspaceName={workspaceName}
        />
      </div>
      <div className={styles.inviteActionArea}>
        <AuthActionStack progress={journey}>
          <Button
            data-testid="invite-primary-button"
            className={styles.invitePrimaryButton}
            variant="primary"
            size="extraLarge"
            onClick={requestToJoin}
            loading={loading}
            disabled={loading}
          >
            {actionLabel}
          </Button>
        </AuthActionStack>
      </div>
    </AuthPageContainer>
  );
};
